import {
    createActiveHomePage,
    createHomePage,
    deleteHomePageById,
    readCurrentHomePage,
    readHomePageById,
    readHomePages,
    replaceHomePage,
} from 'api/home-page';
import { UpdateHomePageRequest } from 'api/home-page/types';
import { PaginateParamsRequest } from 'types/common';
import { HomePageFormData } from 'types/home-page';
import {
    getTransformedAttachmentsToRequest,
    getTransformedHomePageFormFromResponse,
    getTransformedHomePageInfoFromResponse,
} from './utils';

export const createNewHomePage = (data: HomePageFormData) => {
    const requestData = {
        ...data,
        attachments: getTransformedAttachmentsToRequest(data.attachments),
    };
    return createHomePage(requestData).then((res) => res.data);
};

export const updateHomePage = ({ description, attachments }: HomePageFormData, homePageId: string) => {
    const requestData: UpdateHomePageRequest = {
        description: description || null,
        attachments: getTransformedAttachmentsToRequest(attachments),
    };
    return replaceHomePage(requestData, homePageId).then((res) => res.data);
};

export const setActiveHomePage = (homePageId: string) => createActiveHomePage(homePageId).then((res) => res.data);

export const getHomePages = (params: PaginateParamsRequest, ids?: string[]) => {
    const requestParams = {
        ...params,
        ids,
    };
    return readHomePages(requestParams).then((res) => res.data);
};

export const getHomePageDetails = (id: string) => readHomePageById({ id }).then(({ data }) => data);

export const getHomePageFormData = (id: string) =>
    readHomePageById({ id }).then(({ data }) => getTransformedHomePageFormFromResponse(data));

export const getCurrentHomePageFormData = () =>
    readCurrentHomePage().then(({ data }) => getTransformedHomePageInfoFromResponse(data));

export const deleteHomePage = (id: string) => {
    return deleteHomePageById({ id }).then((res) => res.data);
};
